import type { DataFetchingClient } from 'data-fetching-client';
import { queryLoginVerify } from './portalsLoginVerify';

export async function getPortalsLocaleInfo(config: {
  client: DataFetchingClient;
  objectId?: number;
}): Promise<{
  locale: string;
  langEnabled: boolean;
}> {
  const searchParams = new URLSearchParams(window.location.search);
  const localeOverride = searchParams.get('localeOverride');
  if (localeOverride) {
    return { langEnabled: true, locale: localeOverride };
  }
  const loginData = await queryLoginVerify({
    client: config.client,
    objectId: config.objectId,
  }).catch((e: unknown) => {
    console.error('portalsLocaleInfo: loginVerify failed', e);
    return undefined;
  });
  const locale =
    loginData?.data?.result?.preferredLanguage || navigator.language;
  return { langEnabled: true, locale };
}
